import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";
import type { ApiPathGetter } from "@upmind-automation/types";
import type { IAuthConfiguration } from "@upmind-automation/types";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath:
    (): ApiPathGetter =>
    ({ configId }: { configId: IAuthConfiguration["id"] }) => {
      const admin = `api/admin/auth_provider_configurations/${configId}/actors`;
      return { admin };
    }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: `${getters.apiPath(payload).admin}`,
        storeModule: DataModules.AUTH_CONFIGURATIONS_ACTORS,
        params: {
          ...payload.params
        }
      },
      { root: true }
    );
  },
  assignActor: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/create",
      {
        ...payload,
        path: `${getters.apiPath(payload).admin}`,
        storeModule: DataModules.AUTH_CONFIGURATIONS_ACTORS
      },
      { root: true }
    );
  },
  unassignActor: ({ dispatch, getters }, { configId, actorId }) => {
    return dispatch(
      "data/remove",
      {
        path: `${getters.apiPath({ configId }).admin}/${actorId}`,
        storeModule: DataModules.AUTH_CONFIGURATIONS_ACTORS
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
